module.exports = __webpack_public_path__ + "static/media/mainherodown.39dd609f.webp";